import { isNumberString } from "../isNumberString.js";
import { Template } from "./Template.js";
import { TemplateValue } from "./TemplateValue.js";
import { TemplateValueError } from "./TemplateValueError.js";

/**
 * Validates the given template for the given set of values.
 */
export const validateTemplate = (template: Template, values: TemplateValue[]) => {
  const errors: TemplateValueError[] = [];

  for (const variable of template.variables) {
    const value = values.find((item) => item.name === variable.name && item.value.trim() !== "");
    if (value) {
      if (variable.type === "date") {
        if (!value.value.match(/^(\d{4})-(\d{2})-(\d{2})$/)) {
          errors.push({
            name: variable.name,
            messages: ["Please enter the item date in correct format."]
          });
        }
      } else if (variable.type === "amount_eur") {
        if (!isNumberString(value.value)) {
          errors.push({
            name: variable.name,
            messages: ["Please enter the amount as a number."]
          });
        }
      }
    } else {
      errors.push({
        name: variable.name,
        messages: [`Please enter value for ${variable.name}.`]
      });
    }
  }

  return errors;
};
